module.exports = {"Administración de cotizaciones":"Administración de cotizaciones","Listado de cotizaciones":"Listado de cotizaciones","Nombre":"Nombre","Ver cotización":"Ver cotización","Editar cotización":"Editar cotización","Nueva cotización":"Nueva cotización","De":"De","A":"A","Compra":"Compra","Venta":"Venta","Moneda origen":"Moneda origen","Moneda destino":"Moneda destino","Valor venta":"Valor venta","Valor compra":"Valor compra","Fecha":"Fecha"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/cotizaciones/es.json
// module id = 1141
// module chunks = 0